// Components
import { Divider, FormControlLabel, ListItemText, Radio } from '@mui/material'

// Styled
import { styled } from '@mui/material/styles'

const StyledFormControlLabel = styled(FormControlLabel)`
  margin-right: -25px;
  width: 100%;
`

const IntendedDivider = styled(Divider)`
  margin-right: 45px;

  &:last-child {
    display: none;
  }
`

interface Prop {
  value: string
  onClick: () => unknown
  primaryText: string
  secondaryText: string
}
export function RadioButtonListItem({
  onClick,
  value,
  primaryText,
  secondaryText,
}: Prop) {
  return (
    <>
      <StyledFormControlLabel
        value={value}
        control={<Radio sx={{ margin: '22px' }} onClick={onClick} />}
        label={
          <ListItemText
            primary={primaryText}
            secondary={secondaryText}
            primaryTypographyProps={{ variant: 'body2', color: 'neutral900' }}
            secondaryTypographyProps={{
              variant: 'caption1',
              color: 'neutral500',
            }}
          />
        }
      />
      <IntendedDivider />
    </>
  )
}
